import { useCollection, useDocument } from "@/hooks/useFirestore"
import { createManagedMutations } from "@/hooks/useManagedMutations"
import { SchoolYear, collectionName } from "./schoolYear"
import { useGlobalSettings } from "../globalSettings/useGlobalSettings"

export function useSchoolYears() {
   return useCollection<SchoolYear>({
      collectionName,
      transform: (query) => query.orderBy("start_date").reverse(),
   })
}

export function useCurrentSchoolYear() {
   const { data: globalSettings } = useGlobalSettings()
   const schoolYearId = globalSettings?.current_schoolyear_id
   return useDocument<SchoolYear>(collectionName, schoolYearId || "")
}

export function useSchoolYear({ id }: { id: string }) {
   return useDocument<SchoolYear>(collectionName, id)
}

export const {
   useCreateManagedDocument: useCreateSchoolYear,
   useUpdateManagedDocument: useUpdateSchoolYear,
   useDeleteManagedDocument: useDeleteSchoolYear,
} = createManagedMutations<SchoolYear>(collectionName)
